/**
 * Website Analytics - Re-exports from shared package
 * 
 * This file provides a simple wrapper for the game app.
 * The canonical source is packages/utils/src/websiteAnalytics.ts
 */

import {
  initWebsiteAnalytics as sharedInit,
  trackPageVisit as sharedTrackPageVisit,
  trackEmailSubmitted,
} from '@wfvr/utils';
import { SITE_TYPES } from '@wfvr/types';

// API URL - uses same pattern as GameApiService
const API_BASE_URL = import.meta.env.VITE_API_URL || 'https://api.selna.ai';

// Re-export what's needed for the game
export { trackEmailSubmitted };

/**
 * Initialize website analytics for the game app
 */
export function initWebsiteAnalytics(): void {
  sharedInit({ apiUrl: `${API_BASE_URL}/api` });
}

/**
 * Track page visit with GAME_PAGE site type
 */
export function trackPageVisit(): void {
  sharedTrackPageVisit(SITE_TYPES.GAME_PAGE);
}
